import type { FXConfig } from "./fx-engine";
import { readThemeColors, type ThemeColors } from "./theme";

/** Maps the live theme onto FX's colour fields. Page-specific config files
 *  (fx-config-error.ts) layer their own colour mapping on top of this.      */
export function mapTheme(theme: ThemeColors): Partial<FXConfig> {
	return {
		bg: theme.bg,
		dotColor: theme.line,
		color: theme.acc,
	};
}

/** Builds window.FX from the current theme colours (via mapColors) and any
 *  page-specific overrides, then keeps the theme colours in sync on OS theme
 *  change. fx-engine.ts fills in the remaining defaults for any field left
 *  unset.                                                                   */
export function applyFXConfig(
	overrides: Partial<FXConfig> = {},
	mapColors: (theme: ThemeColors) => Partial<FXConfig> = mapTheme,
): void {
	window.FX = {
		...mapColors(readThemeColors()),
		...overrides,
	};

	window
		.matchMedia("(prefers-color-scheme: dark)")
		.addEventListener("change", (): void => {
			Object.assign(window.FX, mapColors(readThemeColors()));
		});
}
